import { useState, useEffect } from "react";
import { useGames } from "../utils/hooks";
import { useNavigate, useParams } from "react-router-dom";
import CustomSvg from "../components/svgs/CustomSvg";
import { AiOutlineArrowLeft } from "react-icons/ai";

const HostGame = () => {
  const { games, getGames } = useGames();
  const [showGames, setShowGames] = useState(true);
  const { gameId } = useParams();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getGames();
  }, []);

  const handleHostClick = () => {
    setLoading(true);
    setTimeout(() => {
      navigateTo(`/game/${matchingGame.id}/create`);
    }, 300); // Optional slight delay for UX smoothness
  };

  const matchingGame = games.find(
    (game) => game.id?.toLowerCase() === gameId?.toLowerCase()
  );

  const navigate = useNavigate();
  const navigateTo = (path) => navigate(path);
  return (
    <div className=" bg-[#130828] min-h-svh p-3">
      <div className="relative flex items-center justify-center py-10">
        {/* Arrow button on the far left */}
        <div className="absolute -left-1">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 text-white"
            style={{
              background: "none",
              border: "none",
              padding: 0,
            }}
          >
            <CustomSvg name="arrow-left" width={20} height={20} color="#fff" />
            <span
              style={{
                fontFamily: "Poppins",
                fontSize: "1.2rem",
                fontWeight: "bold",
              }}
            >
              <AiOutlineArrowLeft width={30} height={30} />
            </span>
          </button>
        </div>

        {/* Centered title */}
        {matchingGame && (
          <h2 className="text-3xl font-bold bg-gradient-to-r from-[#C6BCFF] to-[#3F9217] bg-clip-text text-transparent text-center">
            {matchingGame.title}
          </h2>
        )}
      </div>

      <div>
        <div className="flex justify-center my-4">
          {matchingGame && (
            <img
              src={matchingGame.img}
              alt={matchingGame.title || "Game image"}
              height={300}
              className="max-w-full h-auto rounded-xl shadow-md"
            />
          )}
        </div>
      </div>
      {showGames && matchingGame ? (
        <div key={matchingGame._id}>
          <p className=" text-lg text-white">{matchingGame.caption}</p>
        </div>
      ) : showGames && !matchingGame ? (
        <p>No matching game found.</p>
      ) : null}

      <div>
        <button
          onClick={handleHostClick}
          disabled={loading}
          className={`mt-5 py-3 w-full text-lg text-white rounded-lg transition-colors ${
            loading
              ? "bg-gray-500 cursor-not-allowed"
              : "bg-[#56920D] hover:bg-[#3F9217]"
          }`}
        >
          {loading ? "Loading..." : "HOST GAME"}
        </button>
      </div>
    </div>
  );
};

export default HostGame;
